<template>
  <div v-loading="dataLoading" class="app-content-wrapper security-page">
    <div class="top-wrapper margin-bottom-20">
      <img
        class="img-top-wrapper"
        src="@/assets/images/security/ic-safe.png"
      />
      <div class="margin-left-20">
        <p class="top-title">{{ $t("message.user.securityTitle") }}</p>
        <p class="top-desc">{{ $t("message.user.securityDesc") }}</p>
      </div>
    </div>
    <div>
      <div class="security-item margin-bottom-20">
        <div class="security-item-top" @click="handleRadioChange(1)">
          <span>
            <img v-if="selectType === 1" class="ic-check" src="@/assets/images/ic-radio-checked.png" />
            <img v-else class="ic-check" src="@/assets/images/ic-radio.png" />
          </span>
          <div>
            <p class="security-item-title">{{ $t('message.user.emailCode') }}</p>
            <p class="security-desc">{{ $t('message.user.emailCodeTip') }}</p>
          </div>
        </div>
      </div>
      <div class="security-item">
        <div class="security-item-top" @click="handleRadioChange(2)">
          <span>
            <img v-if="selectType === 2" class="ic-check" src="@/assets/images/ic-radio-checked.png" />
            <img v-else class="ic-check" src="@/assets/images/ic-radio.png" />
          </span>
          <div>
            <p class="security-item-title">
              {{ $t('message.user.payPassword') }}
              <span v-if="hasPayPassword" class="margin-left-27 btn-update-password" @click="handleUpdatePassword">{{ $t('message.user.updatePassword') }}</span>
            </p>
            <p class="security-desc">{{ $t('message.user.payPasswordTip') }}</p>
          </div>
        </div>
        <div v-if="selectType === 2 && !hasPayPassword" class="security-item-content">
          <p class="security-desc margin-bottom-10">{{$t('message.user.settingPayPasswordTip')}}</p>
          <SecurityInput :autofocus="true" type="password" @change="handlePasswordChange" bgColor="white"></SecurityInput>
          <div class="margin-top-20 security-phone-box">
            <p class="security-phone-title">{{$t('message.user.phoneCode')}} / {{`${areaCode || ''} ${phone || ''}`}}</p>
            <div class="security-phone-input">
              <el-input ref="codeRef" v-model="captcha" maxlength="6" class="security-code-input white" :placeholder="$t('message.user.phoneCode')"></el-input>
              <p v-loading="isSending" class="btn-send" @click="handleSendCode">{{countDownTime > 0 ? `${countDownTime}s` : $t('message.user.sendCaptcha')}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-button class="margin-top-20" type="primary" @click="handleSave">{{$t('message.common.confirm')}}</el-button>

    <validation-modal
      ref="validationModal"
      :titleText="$t('message.user.resetPayPassword')"
      :default-function="updatePassword">
      <template>
        <p class="security-desc">{{$t('message.user.settingPayPasswordTip')}}</p>
      </template>
      <p class="security-title margin-top-10 margin-bottom-10">{{$t('message.user.newPayPasswrod')}}</p>
      <SecurityInput ref="securityInputRef" :autofocus="true" type="password" @change="handlePasswordChange"></SecurityInput>
      <div class="margin-top-10 security-phone-box">
        <p class="security-title">{{$t('message.user.phoneCode')}} / {{`${areaCode || ''} ${phone || ''}`}}</p>
        <div class="security-phone-input">
          <el-input ref="codeRef" v-model="captcha" maxlength="6" class="security-code-input" :placeholder="$t('message.user.phoneCode')"></el-input>
          <p v-loading="isSending" class="btn-send" @click="handleSendCode">{{countDownTime > 0 ? `${countDownTime}s` : $t('message.user.sendCaptcha')}}</p>
        </div>
      </div>
    </validation-modal>
  </div>
</template>
<script>
import SecurityInput from '@/components/form/security-input.vue';
import ValidationModal from '@/components/modal/base-modal/validation-modal.vue';
import { ShowSuccessMessage, ShowWarningMessage } from '@/components/modal/tips/message-tips';
import { getCurrentMenu } from '@/layout/base/components/inavbar/utils';
import { getOperatorInfo } from '@/views/account/permission/api/operator';
import {
  getPaySafeConfig, updatePaySafeConfig, getPhoneCaptcha,
  updatePayPassword,
} from '@/views/account/security/api/security';

export default {
  components: {
    ValidationModal,
    SecurityInput,
  },
  data() {
    return {
      dataLoading: false,
      selectType: 1,
      hasPayPassword: false,
      password: '',
      phone: '',
      areaCode: '',
      countDownTime: 0,
      captcha: '',
      isSending: false,
      showSubmitBtn: false,
    };
  },
  beforeCreate() {
    try {
      const menu = getCurrentMenu(this.$store.getters.permission.menus, {
        path: '/account/security',
        meta: {
          resourceCode: 'account:security',
        },
      });
      const index = menu.childrenNode[0].menuUrl;
      if (index !== '/account/security/payment') {
        this.$router.push({ path: index });
      }
    } catch (err) {
      //
    }
  },
  mounted() {
    this.initMethod();
  },
  beforeDestroy() {
    this.timer && clearTimeout(this.timer);
  },
  methods: {
    async initMethod() {
      this.dataLoading = true;
      try {
        const res = await getPaySafeConfig();
        this.hasPayPassword = !!res.hasPayPassword;
        this.selectType = +res.mode === 2 ? 2 : 1;
        this.originalSelectType = this.selectType;
        const user = await getOperatorInfo();
        this.phone = user.operatorPhoneNumber;
        this.areaCode = user.areaCode;
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
    handleRadioChange(type) {
      this.selectType = type;
      this.showSubmitBtn = (this.originalSelectType !== +type);
    },
    handlePasswordChange(value) {
      this.password = value;
      if (value.length === 6) {
        this.$refs.codeRef.focus && this.$refs.codeRef.focus();
      }
    },
    async handleSendCode() {
      if (!this.password || this.password.length < 6) {
        ShowWarningMessage(this.$t('message.validator.input', { input: this.$t('message.user.payPassword') }));
        return;
      }
      this.isSending = true;
      try {
        const lang = this.$store.getters.app.currentLan;
        const language = lang === 'zh-cn' ? 'zh' : lang;
        const res = await getPhoneCaptcha({
          language,
        });
        this.requestId = res;
        this.countDownTime = 59;
        this.timer = setInterval(() => {
          this.countDownTime -= 1;
          if (this.countDownTime <= 0) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      } catch (err) {

      }
      this.isSending = false;
    },
    async handleSave() {
      this.dataLoading = true;
      try {
        if (this.selectType === 2 && !this.hasPayPassword) { // 若设置支付密码，则先判断是否存在支付密码
          const res = await this.updatePassword();
          if (!res) {
            this.dataLoading = false;
            return;
          }
        }
        if (this.showSubmitBtn) {
          await updatePaySafeConfig({
            mode: this.selectType,
          });
        }
        this.originalSelectType = this.selectType;
        this.showSubmitBtn = false;
        ShowSuccessMessage(this.$t('message.operateSuccessfulTip'));
      } catch (err) {

      }
      this.dataLoading = false;
    },
    handleUpdatePassword(e) {
      e.stopPropagation();
      this.password = '';
      this.captcha = '';
      this.countDownTime = 0;
      this.timer && clearTimeout(this.timer);
      this.$refs.validationModal.openModalAndCallBack(() => {
        this.$refs.securityInputRef.reset();
      });
    },
    async updatePassword() {
      if (!this.password || this.password.length < 6) {
        ShowWarningMessage(this.$t('message.validator.input', { input: this.$t('message.user.payPassword') }));
        return Promise.reject(new Error());
      }
      if (!this.captcha) {
        ShowWarningMessage(this.$t('message.validator.input', { input: this.$t('message.user.captcha') }));
        return Promise.reject(new Error());
      }
      await updatePayPassword({
        payPassword: this.password,
        captcha: this.captcha,
        areaCode: this.areaCode,
        phone: this.phone,
      });
      this.hasPayPassword = true;
      return true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";

.security-page {
  .top-wrapper {
    display: flex;
    align-items: center;
    margin-top: 36px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(0, 32, 63, 0.08);

    .img-top-wrapper {
      width: 110px;
      height: 102px;
    }

    .top-title {
      font-size: 16px;
      font-family: PingFangTC-Semibold, PingFangTC;
      font-weight: 600;
      color: $color-text-primary;
      line-height: 28px;
    }

    .top-desc {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: $color-text-primary;
      line-height: 21px;
    }
  }

  .security-item {
    background: #F1F5F7;
    border-radius: 2px;
    .security-item-top {
      display: flex;
      align-items: center;
      height: 100px;
      padding-left: 25px;
      padding-right: 30px;
      cursor: pointer;

      .ic-check {
        width: 20px;
        height: 20px;
        margin-right: 15px;
      }

      .security-item-title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        color: $color-text-primary;
        line-height: 25px;

        .btn-update-password {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: $color-primary;
          line-height: 32px;
          cursor: pointer;
        }
      }
    }

    .security-item-content {
      border-top: 1px solid rgba(0,32,63,0.15);
      padding: 20px 60px;
    }
  }
}
</style>
<style lang="scss">
@import "@/styles/variables.scss";

.security-page {
  .security-desc {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: $color-text-primary;
    line-height: 26px;
    word-break: break-word;
    word-wrap: break-word;
  }

  .security-title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: $color-text-primary;
    line-height: 26px;
  }

  .security-phone-box {
    width: 340px;
    .security-phone-title {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: $color-text-primary;
      line-height: 26px;
    }

    .security-phone-input {
      position: relative;
      height: 44px;
      width: 100%;
      .btn-send {
        position: absolute;
        top: 0;
        right: 10px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: $color-primary;
        line-height: 32px;
        cursor: pointer;
      }
    }

    .security-code-input {
      position: relative;
      height: 44px;
      width: 100%;

      .el-input__inner {
        height: 100%;
      }

      &.white {
        .el-input__inner {
          background-color: white;
        }
      }
    }
  }

  #validationId {
    .security-phone-box {
      width: 100%;
    }
    .security-code-input {
      position: relative;
      .el-input__inner {
        height: 100%;
      }
    }
  }
}
</style>
